import { render, staticRenderFns } from "./deviceActivate.vue?vue&type=template&id=b8804d74&scoped=true"
import script from "./deviceActivate.vue?vue&type=script&lang=js"
export * from "./deviceActivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8804d74",
  null
  
)

export default component.exports